exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PresentationsStart{width:100%;max-width:1024px;display:flex;flex-direction:column;align-items:center}.PresentationsStart h2{background:#e5e5e5;width:100%;padding:10px;border-radius:5px;text-align:center}.PresentationsStart .code{color:#155724;background-color:#d4edda;border-color:#c3e6cb;padding:10px;font-weight:700;border-radius:5px;font-size:26px;margin-bottom:20px}.PresentationsStart .active-student{display:flex;align-items:center;justify-content:center;flex-direction:row;margin-bottom:20px}.PresentationsStart .active-student div{background:#ebf8f2;margin-top:20px;padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/PresentationsStart/style.scss
// module id = 5068
// module chunks = 0